module.exports = __webpack_public_path__ + "static/media/refrigDying.f345db0c.png";